<div class="flex-vertical gap-24 width-100pc">
  <div class="flex-vertical gap-8 width-100pc">
    <div class="body-1" [innerHTML]="primaryLabel"></div>
    <oui-textarea
      class="width-100pc"
      [control]="primaryControl"
      [errors]="errors"
      placeholder="Saisissez vos precisions*"
      [resizeEnabled]="true"></oui-textarea>
  </div>

  <div class="flex-vertical gap-8 width-100pc">
    <div class="body-1" [innerHTML]="secondaryLabel"></div>
    <oui-textarea
      class="width-100pc"
      [control]="secondaryControl"
      [errors]="errors"
      placeholder="Saisissez vos precisions*"
      [resizeEnabled]="true"></oui-textarea>
  </div>
</div>
